<template>
  <b-row v-bind="$attrs">
    <template v-if="value">
      <b-col v-for="(property, index) in formProperties" :key="index">
        <SingleElementGenerator :properties="property" v-model="value" />
      </b-col>
    </template>
    <slot name="additionalFields"></slot>
  </b-row>
</template>

<script>
import SingleElementGenerator from "@/components/form-elements/generators/SingleElementGenerator.vue";

export default {
  props: {
    formProperties: {
      type: Array,
      required: true
    },
    value: {
      required: true
    }
  },
  components: {
    SingleElementGenerator
  }
};
</script>

<style lang="scss" scoped></style>
